import { useEffect, useState } from 'react';
import { getVetVisits } from './api';
import SectionHeader from './SectionHeader';

const PERIOD_OPTIONS = [
  { label: '2 мес', value: 2 },
  { label: '6 мес', value: 6 },
  { label: '12 мес', value: 12 },
];

export default function VisitsBlock({ petId, docs, onDocsClick }) {
  const [months, setMonths] = useState(2);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    getVetVisits(petId, months)
      .then(setData)
      .catch(() => setData([]))
      .finally(() => setLoading(false));
  }, [petId, months]);

  return (
    <section className="card-section" id="section-visits">
      <SectionHeader
        title="Визиты к врачу"
        periodMode="none"
        sectionKey="visits"
        docs={docs}
        onDocsClick={onDocsClick}
      />

      {/* Переключатель периода */}
      <div className="visits-period-tabs">
        {PERIOD_OPTIONS.map((opt) => (
          <button
            key={opt.value}
            className={`visits-tab${months === opt.value ? ' visits-tab-active' : ''}`}
            onClick={() => setMonths(opt.value)}
          >
            {opt.label}
          </button>
        ))}
      </div>

      {loading ? null : data.length === 0 ? (
        <p style={{ color: '#888', fontSize: 14, margin: 0 }}>Нет визитов за этот период</p>
      ) : (
        data.map((visit) => (
          <div key={visit.id} className="visit-row">
            <div className="visit-header">
              <span className="visit-date">📅 {visit.date}</span>
              <span className="visit-spec">{visit.specialization}</span>
            </div>
            {visit.notes && (
              <p className="visit-notes">{visit.notes}</p>
            )}
          </div>
        ))
      )}
    </section>
  );
}
